import { render, staticRenderFns } from "./CollectionLinkedFileDetails.vue?vue&type=template&id=d01cd5e6&scoped=true"
import script from "./CollectionLinkedFileDetails.vue?vue&type=script&lang=js"
export * from "./CollectionLinkedFileDetails.vue?vue&type=script&lang=js"
import style0 from "./CollectionLinkedFileDetails.vue?vue&type=style&index=0&id=d01cd5e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01cd5e6",
  null
  
)

export default component.exports